import { ThemeAPI } from '@ingestro/importer-react'

const spinnerIcon = {
  '& > *': { display: 'none' },
  width: '48px',
  height: '48px',
  border: '4px solid #e5e7eb',
  borderTopColor: '#f43f5e',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
  '@keyframes spin': {
    to: { transform: 'rotate(360deg)' },
  },
}

export const reviewEntries: ThemeAPI['reviewEntries'] = {
  duplicateButton: {
    display: 'none !important',
  },
  // Nuvo's ThemeAPI requires styles as a JS object, so we can't use Tailwind classes
  // or CSS files. Instead, we reference f0 CSS custom properties directly.
  // f0 vars store raw HSL channels (e.g. --critical-50: 5 100% 65%), so we wrap them
  // with hsl() and append the opacity: hsl(var(--critical-50) / .1) is equivalent
  // to Tailwind's bg-f1-background-critical class (10% opacity background).
  table: {
    td: {
      error: {
        backgroundColor: 'hsl(var(--critical-50) / .2)', // f1-background-critical
      },
      warning: {
        backgroundColor: 'hsl(var(--warning-50) / .2)', // f1-background-warning
      },
      info: {
        backgroundColor: 'hsl(var(--info-50) / .2)', // f1-background-info
      },
    },
  },
  submitModal: {
    icon: {
      display: 'none',
    },
    root: {
      '& span.w-1\\/2': {
        width: 'auto',
        marginRight: '8px', // mr-2 in f0 (equivalent to deprecated theme.dimensions.s8)
      },
    },
  },
  submitLoading: {
    icon: spinnerIcon,
  },
}
